export default __webpack_public_path__ + "static/media/expand_more.cf238cda.svg";